export default __webpack_public_path__ + "static/media/history_1960_01.00ff5358.png";